import React from "react";
import styled from "styled-components";
import { hasAgeRange, Unit } from "../common/api";
import { ageRange } from "../common/utils";
import { useTranslation } from "react-i18next";
import { SPACE_SM } from "../common/spacing";
import { COLOR_TEXT_PRIMARY } from "../common/colors";
import {
  CellCover,
  CellMetaItem,
  CellMetaRow,
  clampLines,
} from "../common/CommonStyles";

const ATTRIBUTE_SPACING = 14;

const StyledUnitItemBody = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  ${clampLines(2)}
  margin-top: ${SPACE_SM}px;
  color: ${COLOR_TEXT_PRIMARY};
  font-weight: 500;
  font-size: 16px;
`;

const MetaRow = styled(CellMetaRow)`
  margin-top: ${SPACE_SM}px;
`;

export const UnitItemBody = ({ unit }: { unit: Unit }) => {
  const { t } = useTranslation();

  return (
    <StyledUnitItemBody key={unit.id}>
      <CellCover
        url={unit.cover_image}
        alt={t("unit_cover_content_description", { title: unit.title })}
        isElevated
      />
      <Title>{unit.title}</Title>
      <MetaRow $gap={ATTRIBUTE_SPACING}>
        <CellMetaItem icon="lessonCount">{unit.lesson_count}</CellMetaItem>
        {hasAgeRange(unit) && (
          <CellMetaItem icon="ageRange">
            {ageRange(t, unit.age_min, unit.age_max)}
          </CellMetaItem>
        )}
      </MetaRow>
    </StyledUnitItemBody>
  );
};
